import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers"; //, checkIsActive
import { RecentHistory } from "./RecentHistory";
import {
  dashboardFundCounterApi,
  dashboardStatisticsCounterApi,
  recentTransactionListApi,
} from "../../axios/services/services";
import { FundsCounter } from "./FundsCounter";
import { StatisticsCounter } from "./StatisticsCounter";
import ErrorModal from "../modules/Modal/ErrorModal";
import { isUnauthorized } from "../utils/utils";

export function DashboardPage({ history }) {
  const [recentTransactionList, setRecentTransactionList] = useState(null);
  const [selectedTab, setSelectedTab] = useState("first");
  const [isUpdateSelectedTab, setUpdateSelectedTab] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [fundCounterList, setFundCounterList] = useState(null);
  const [statisticsCounterList, setStatisticsCounterList] = useState(null);

  useEffect(() => {
    async function getRecentTransactionList() {
      const recentTransactionListResponse = await recentTransactionListApi(
        selectedTab
      );
      if (recentTransactionListResponse.Error) {
        isUnauthorized({ response: recentTransactionListResponse });
        setErrorMessage(recentTransactionListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      const { data = [] } = recentTransactionListResponse || {};
      setRecentTransactionList(data);
    }
    getRecentTransactionList();
  }, [isUpdateSelectedTab]);

  useEffect(() => {
    async function getFundCounterList() {
      const fundCounterListResponse = await dashboardFundCounterApi();
      if (fundCounterListResponse.Error) {
        isUnauthorized({ response: fundCounterListResponse });
        setErrorMessage(fundCounterListResponse.Error.message);
        handleErrorModalShow();
        return;
      }

      setFundCounterList(
        fundCounterListResponse ? fundCounterListResponse : null
      );
    }
    getFundCounterList();
  }, []);

  useEffect(() => {
    async function getStatisticsCounterList() {
      const statisticsCounterListResponse = await dashboardStatisticsCounterApi();
      if (statisticsCounterListResponse.Error) {
        isUnauthorized({ response: statisticsCounterListResponse });
        setErrorMessage(statisticsCounterListResponse.Error.message);
        handleErrorModalShow();
        return;
      }

      setStatisticsCounterList(
        statisticsCounterListResponse && statisticsCounterListResponse
          ? statisticsCounterListResponse
          : []
      );
    }
    getStatisticsCounterList();
  }, []);

  const handleSetSelectedTab = (selectedTab) => {
    setSelectedTab(selectedTab);
    updateSelectedTab();
  };

  const updateSelectedTab = () => {
    setUpdateSelectedTab(Math.random());
  };

  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };

  return (
    <>
      <FundsCounter fundCounterList={fundCounterList} />
      <StatisticsCounter statisticsCounterList={statisticsCounterList} />
      <RecentHistory
        recentTransactionList={recentTransactionList}
        selectedTab={selectedTab}
        setSelectedTab={handleSetSelectedTab}
      />
      <ErrorModal
        message={errorMessage}
        isErrorModalOpen={isErrorModalOpen}
        hideErrorModal={handleErrorModalHide}
        errorIcon={
          <div className="danger-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
              />
            </span>
          </div>
        }
        errorButtonLabel={"Close"}
        errorOnClick={handleErrorModalHide}
      />
    </>
  );
}
